import sendRequest from "@/libs/sendRequest"

const preferences = {
    namespaced: true,
    state: {
        preference: {},
        preferences: [],
        error: false,
        last_page: null,
        total_pages: null
    },
    getters: {
        getPreference: (state) => state.preference,
        getPreferences: (state) => state.preferences,
        getLastPage: (state) => state.last_page,
        getTotalPages: (state) => state.total_pages,
        getError: (state) => state.error
    },
    mutations: {
        setPreference: (state, payload) => state.preference = payload,
        setPreferences: (state, payload) => state.preferences = payload,
        setLastPage: (state, payload) => state.last_page = payload,
        setTotalPages: (state, payload) => state.total_pages = payload,
        setError: (state, payload) => state.error = payload,
    },
    actions: {
        list: async({commit, dispatch, rootGetters}, query) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('admin/catalogs/preferences/list', 'GET', null, query, custom_headers)
            if(response.success && response.data) {
                if(query.datatable) {
                    commit('setPreferences', response.data.list.result)
                    commit('setTotalPages', response.data.list.total_pages)
                    commit('setLastPage', response.data.list.total_pages == query.page)
                } else {
                    commit('setPreferences', response.data.list)
                }
                dispatch('hiddenLoading', null, { root: true })
            }
            else if(!response.success && response.errors) {
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', 'An error has occurred try later', { root: true })
            }
            else { dispatch('lostConection', null, { root: true }) }
        },
        view: async({commit, dispatch, rootGetters}, query) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('admin/catalogs/preferences/view', 'GET', null, query, custom_headers)
            if(response.success && response.data) {
                commit('setPreference', response.data.view)
                dispatch('hiddenLoading', null, { root: true })
            }
            else if(!response.success && response.errors) {
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', 'An error has occurred try later', { root: true })
            }
            else { dispatch('lostConection', null, { root: true }) }
        },
        add: async({commit, dispatch, rootGetters}, body) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('admin/catalogs/preferences/add', 'POST', body, null, custom_headers)
            if(response.success && response.data) {
                dispatch('showAlert', 'The preference has been added successfully', { root: true })
                commit('setError', false)
            }
            else if(!response.success && response.errors) {
                let messages = []
                for(let error in response.errors) {
                    switch(response.errors[error].code) {
                        case 'error_empty_name': messages.push('Error: Please add a name.'); break
                        case 'error_preference_already_exists': messages.push('Error: The preference already exists.'); break
                        default: messages.push('An error has occurred try later'); break
                    }
                }
                commit('setError', true)
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', messages, { root: true })
            }
            else { dispatch('lostConection', null, { root: true }) }
        },
        update: async({commit, dispatch, rootGetters}, data) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('admin/catalogs/preferences/update', 'PUT', data.body, data.query, custom_headers)
            if(response.success && response.data) {
                dispatch('showAlert', 'Preference updated successfully', { root: true })
                commit('setError', false)
            }
            else if(!response.success && response.errors) {
                let messages = []
                for(let error in response.errors) {
                    switch(response.errors[error].code) {
                        case 'error_empty_name': messages.push('Error: Please add a name.'); break
                        case 'error_preference_inactive': messages.push('Error: preference is inactive'); break
                        case 'error_preference_already_exists': messages.push('Error: The preference already exists.'); break
                        default: messages.push('An error has occurred try later'); break
                    }
                }
                commit('setError', true)
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', messages, { root: true })
            }
            else { dispatch('lostConection', null, { root: true }) }
        },
        delete: async({commit, dispatch, rootGetters}, id) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('admin/catalogs/preferences/delete', 'DELETE', null, { id_preferences: id }, custom_headers)
            if(response.success && response.data) {
                dispatch('showAlert', 'The preference has been successfully removed', { root: true })
                commit('setError', false)
            }
            else if(!response.success && response.errors) {
                commit('setError', true)
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', 'An error has occurred try later', { root: true })
            }
            else { dispatch('lostConection', null, { root: true }) }
        }
    }
}

export default preferences
